import { Badge } from 'antd';
import styled from 'styled-components';

import { ColorEnum } from '@enum/style/color.enum';

export const StyledBadge = styled(Badge)`
  & .ant-badge-status-text {
    font-weight: 500;
    font-size: 14px !important;
  }

  &.ant-badge-status .ant-badge-status-success {
    box-shadow: 0 0 0 3px ${ColorEnum.IndicationSuccess50};
  }
`;
